import React from 'react'

function TrendingModelsTooltip() {
  return (
    <div className="trending-models-tooltip">
      See the daily top new uploads.<br />
      Want your models featured?<br />
      <a href="/pages/how-trending-models-work" target="_blank" className="tooltip-link">Learn how trending models work</a>
    </div>
  )
}

export default TrendingModelsTooltip
